var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 169,
    viewBox: "0 0 192 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3828 23.939L75.3187 44.9977C75.3167 45.6555 75.8447 46.1923 76.5025 46.2012L96.392 46.4704C109.664 46.1684 136.187 52.7546 139.618 79.4716C141.839 89.3488 139.259 113.249 112.435 121.583C110.209 122.274 107.863 122.516 105.532 122.509L50.5217 122.342C49.8589 122.34 49.3233 121.801 49.3253 121.138L49.6897 1.35101C49.6918 0.670716 50.2461 0.127759 50.9259 0.154152C54.8983 0.308381 59.7124 0.468859 64.8874 0.641364C84.2183 1.28576 108.584 2.09799 112.917 3.37926C134.768 5.84248 180.771 24.3347 189.986 74.4889C194.22 94.0182 188.612 141.251 131.168 162.647C116.419 168.141 100.233 168.251 84.4301 168.358C83.2928 168.366 82.1574 168.374 81.0246 168.383L57.3779 168.586L1.19999 168.415C0.537248 168.413 0.00162557 167.874 0.00364172 167.211L0.456909 18.2171C0.458091 17.8287 0.647241 17.4648 0.964516 17.2407L23.4255 1.37323C24.2217 0.810746 25.3209 1.38213 25.3179 2.35698L25.0953 75.5281L25.1062 143.666C25.1063 144.328 25.6413 144.864 26.3025 144.866L91.5505 145.065C113.799 145.132 165.214 133.99 165.373 81.6043C165.436 61.1793 144.028 20.9909 76.5642 22.7467C75.9185 22.7635 75.3847 23.293 75.3828 23.939ZM99.361 65.9958L75.2545 65.9225L75.142 102.901L99.2485 102.974C109.217 103.004 117.322 94.9481 117.352 84.9801L117.355 84.0994C117.385 74.1314 109.329 66.0262 99.361 65.9958Z",
    fill: "url(#paint0_linear_46_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_9",
    x1: 189.655,
    y1: 183.365,
    x2: -38.6509,
    y2: -159.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CC2D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinal);
export default __webpack_public_path__ + "static/media/final.527ebad658d584cced29c6c8784af729.svg";
export { ForwardRef as ReactComponent };